import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Privacy_Policy_Seo from '../../SEO/Privacy_Policy_Seo';
import AOS from 'aos';

function PrivacyPolicy() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Privacy_Policy_Seo />
                    <Header />
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Privacy Policy</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Privacy Policy</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Privacy Policy section start */}
                    <div className="privacy-policy-area ptb-100">
                        <div className="container">
                            <div className="privacy-policy-content">
                                <div className="information-collection">
                                    <p className="mb-2">
                                        We at KP Agency Limited are committed to protecting your privacy and this privacy policy sets out
                                        the use we make of any your information that we may obtain during the business relationship. This
                                        policy sets out the basis on which any personal data we collect from you, or that you provide to us,
                                        during the business relationship. Please read the following carefully to understand our views and
                                        practices regarding your personal data and how we will treat it.
                                    </p>
                                    <p>
                                        We ask that persons under the age of 18 (which we treat as children and minors) refrain from using
                                        our Service or submitting any personal information to us. Persons under the age of 18 years are not
                                        eligible to use our Service and if we discover that someone under the age of 18 has registered a
                                        Profile with us, we will close it.
                                    </p>
                                    <p>
                                        You may give us information about you by filling in forms on our website or by corresponding with
                                        us by phone, e-mail or otherwise. This includes (but is not limited to) information you provide when
                                        you register with us, transfer money using our office or websites and when you report a problem
                                        with us.
                                    </p>
                                    <p>The information you give us may include:</p>
                                    <ul className="info-number-list">
                                        <li><span>1.</span>
                                            Name, address, job title and email address
                                        </li>
                                        <li><span>2.</span>
                                            Date of birth
                                        </li>
                                        <li><span>3.</span>
                                            Phone number
                                        </li>
                                        <li><span>4.</span>
                                            Financial and Source of Fund information
                                        </li>
                                        <li><span>5.</span>
                                            Payment reason
                                        </li>
                                        <li><span>6.</span>
                                            Geographic location
                                        </li>
                                        <li><span>7.</span>
                                            Copies of identification
                                        </li>
                                        <li><span>8.</span>
                                            Address proof
                                        </li>
                                    </ul>
                                    <p>The main reason we use this information is to provide you with details about our products and
                                        services, but we (or third party data processors, agents and sub-contractors acting on our behalf)
                                        may also use the information:</p>
                                    <ul className="info-number-list">
                                        <li><span>1.</span>
                                            To help us perform our services
                                        </li>
                                        <li><span>2.</span>
                                            To communicate with you
                                        </li>
                                        <li><span>3.</span>
                                            To assess the risk of performing our services
                                        </li>
                                        <li><span>4.</span>
                                            To enable us to enforce our rights under our terms and conditions if necessary
                                        </li>
                                        <li><span>5.</span>
                                            To administer our Sites and for internal operations, including troubleshooting, data analysis, testing,
                                            research, statistical and survey purposes
                                        </li>
                                        <li><span>6.</span>
                                            To improve our products and services’‚· As part of our efforts to keep our Sites safe and secure;
                                        </li>
                                        <li><span>7.</span>
                                            For promotional purposes including, without limitation, to share the personal data with businesses
                                            in our group and with selected third parties whom we believe have products or services that may be
                                            of interest to you
                                        </li>
                                        <li><span>8.</span>
                                            To measure or understand the effectiveness of advertising we serve to you and others, and to
                                            deliver relevant advertising to you
                                        </li>
                                        <li><span>9.</span>
                                            From time to time, we may also use your information to contact you for market research purposes
                                            We may combine information we receive from other sources with information you give to us and
                                            information we collect about you. We may use this information and the combined information for
                                            the purposes set out above (depending on the types of information we receive).
                                        </li>
                                    </ul>
                                    <p>
                                        The data that we collect from you may be transferred to, and stored at, a destination outside the
                                        European Economic Area ("EEA"). It may also be processed by staff operating outside the EEA who
                                        works for us or for one of our suppliers. Such staff maybe engaged in, among other things, the
                                        fulfillment of your order, the processing of your payment details and the provision of support
                                        services. By submitting your personal data, you agree to this transfer, storing or processing. We will
                                        take all steps reasonably necessary to ensure that your data is treated securely and in accordance
                                        with this privacy policy.
                                    </p>
                                    <p>
                                        All information you provide to us is stored on our secure servers. Any payment transactions will
                                        be <strong>encrypted</strong> [using SSL technology]. Where we have given you (or where you have chosen) a
                                        password which enables you to access certain parts of our Website, you are responsible for keeping
                                        this password confidential. We ask you not to share a password with anyone.
                                    </p>
                                    <p>
                                        We are committed to ensuring that your information is secure. In order to prevent unauthorised
                                        access or disclosure, we have put in place suitable physical, electronic and managerial procedures
                                        to safeguard and secure the information we collect online.
                                    </p>
                                    <p>
                                        We will only retain your information for as long as is necessary for providing our service to you,
                                        usually no more than 5 years after the end of the business relationship.
                                    </p>
                                    <p>
                                        Under the GDPR, individuals have:
                                    </p>
                                    <ul className="info-number-list">
                                        <li><span>1.</span>
                                            The right to access –this means that individuals have the right to request access to their personal
                                            data and to ask how their data is used by the company after it has been gathered. We will provide a
                                            copy of the personal data, free of charge and in electronic format if requested.
                                        </li>
                                        <li><span>2.</span>
                                            The right to be forgotten – if consumers are no longer customers, or if they withdraw their consent
                                            from a company to use their personal data, then they have the right to have their data deleted. We
                                            will not use their data in further processing.
                                        </li>
                                        <li><span>3.</span>
                                            The right to data portability – Individuals has a right to transfer their data from one service provider
                                            to another. And it must happen in a commonly used and machine readable format.
                                        </li>
                                        <li><span>4.</span>
                                            The right to be informed – this covers any gathering of data by companies, and individuals must be
                                            informed before data is gathered. Consumers have to opt in for their data to be gathered, and
                                            consent must be freely given rather than implied.
                                        </li>
                                        <li><span>5.</span>
                                            The right to have information corrected – this ensures that individuals can have their data updated
                                            if it is out of date or incomplete or incorrect. We will update the information as informed.
                                        </li>
                                        <li><span>6.</span>
                                            The right to restrict processing – Individuals can request that their data is not used for processing.
                                            Their record can remain in place, but not be used. We will not use their data for further processing,
                                            if requested.
                                        </li>
                                        <li><span>7.</span>
                                            The right to object – this includes the right of individuals to stop the processing of their data for
                                            direct marketing. There are no exemptions to this rule, and any processing must stop as soon as the
                                            request is received. In addition, this right must be made clear to individuals at the very start of any
                                            communication.
                                        </li>
                                        <li><span>8.</span>
                                            The right to be notified – If there has been a data breach which compromises an individual’s
                                            personal data, we will inform the individual within 72 hours of first having become aware of the
                                            breach.
                                        </li>
                                    </ul>
                                    <p>
                                        You can always exercise your right at any time by contacting us at <NavLink to="mailto:info@ifepay.co.uk">info@ifepay.co.uk</NavLink> The GDPR
                                        mandates company to take technical and organizational measures to achieve a level of security
                                        appropriate to the imminent risk. This has become more urgent in wake of increasing cyber security
                                        threat to organisations. We advocate tokenisation, encryption of data, constant assurance of
                                        confidentiality, integrity, availability, and resilience of processing system and services to comply
                                        with GDPR. Our Privacy policy is embedded in the company’s design throughout its lifecycle.
                                    </p>
                                    <p>
                                        The GDPR introduces mandatory security breach notification and requires administrative and
                                        technical safeguards for personal data to reduce identified risks and to prevent data breaches. The
                                        data subject is required to be notified without undue delay if the breach portends high risk to his
                                        rights and freedoms. Notification can be dispensed with if the data breach is unlikely to result in any
                                        risk to the data subject. We will inform the supervisory authority of data breach incident within 72
                                        (Seventy-two) hours of discovery. In addition, the company has an incidence response plan and
                                        trained its employee on how to respond.
                                    </p>
                                    <p>
                                        We also, follow following Steps for processing EU personal data to comply with GDPR:
                                    </p>
                                    <ul className="info-number-list">
                                        <li><span>1.</span>
                                            The “flow of personal data from countries outside the EU and International organisations are
                                            necessary for the expansion of international trade and cooperation.” Being a money remittance
                                            company our operations involve transfer of personal data of employees and clients across
                                            jurisdictions to manage our global workforce and ease operations as our processing is outsourced
                                            too but we have <strong>Binding corporate rules</strong> - our internal codes of conduct. We export personal data
                                            from the territory of the EU to other companies within our group located in third countries.
                                        </li>
                                    </ul>
                                    <p>
                                        We also, follow following Step for processing EU personal data to comply with GDPR:
                                    </p>
                                    <ul className="info-number-list">
                                        <li><span>1.</span>
                                            We will ensure consent is freely given and data subjects must “opt-in” rather than “opt-out” of data
                                            collection schemes. We will utilise personal data strictly for the purpose of collection and keep it
                                            only as long as needed.
                                        </li>
                                        <li><span>2.</span>
                                            We will ensure security of personal data at rest and in transit with strong encryption. Tokenization
                                            can be adopted to ensure safeguard.
                                        </li>
                                        <li><span>3.</span>
                                            We have developed a data security breach response scheme and comprehensive incidence
                                            response plan. We trained our employees on how to identify a breach in real-time and spot
                                            potential threat. The notification and report should be prompt.
                                        </li>
                                        <li><span>4.</span>
                                            We will review and regularly update our privacy policy, and other documentation and
                                            communications. Information provided in our privacy policy will always be easy to understand.
                                        </li>
                                        <li><span>5.</span>
                                            We will conduct privacy and data security audit. Carefully evaluate the existing data subjects’ data
                                            and processing activities and detect potential inconsistency with the GDPR.
                                        </li>
                                        <li><span>6.</span>
                                            We will regularly run compliance test before implementing a new technology.
                                        </li>
                                        <li><span>7.</span>
                                            We will ensure Cross-border data transfer policy complies with the GDPR by our binding corporate
                                            rules.
                                        </li>
                                    </ul>
                                    <p>
                                        If you have any questions about our Privacy Policy or your information, please contact us in writing to;
                                    </p>
                                    <h4>K P Agency Limited</h4>
                                    <ul className="info-number-list">
                                        <li>
                                            <strong>Address:</strong> Suite 5, Community House 19-21 Eastern Road, Romford, Havering, RM1 3NH, UNITED KINGDOM
                                        </li>
                                        <li>
                                            <strong>Phone Number:</strong> <NavLink to="tel:02030061093">02030061093</NavLink> / <NavLink to="tel:07707337351">07707337351</NavLink>
                                        </li>
                                        <li>
                                            <strong>Email:</strong> <NavLink to="mailto:info@ifepay.co.uk">info@ifepay.co.uk</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Privacy Policy section end */}
                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </div>
    );
}

export default PrivacyPolicy
